export default {
  experimentId: '20',
  serverUrl: 'https://magpie-cogsciprag.fly.dev',
  socketUrl: 'wss://magpie-cogsciprag.fly.dev/socket',
  // this will be used in prolific mode
  completionUrl: 'https://app.prolific.com/submissions/complete?cc=C4QM9V9C',
  contactEmail: 'polina.tsvilodub@uni-tuebingen.de',
  // Either 'debug', 'directLink' or 'prolific'
  mode: 'prolific',
  language: 'en'
};
